import React from 'react';
import { Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import { UserRoleSelect } from '@/components/views/SettingsView/BrokerageUsersTable/UserRoleSelect';
import { AdminFieldLabel } from '@/admin/shared/AdminFieldLabel';
import { USER_FIELD_LABELS } from '../userFormValues';

/** The user drawers' Role, chosen from the CRM's roles as in the user profile (optional). */
export const RoleField = () => {
	const { values, setFieldValue } = useFormikContext();
	return (
		<Grid size={{ xs: 12, sm: 6 }}>
			<AdminFieldLabel name='role'>{USER_FIELD_LABELS.role}</AdminFieldLabel>
			<UserRoleSelect
				size='medium'
				value={values.role}
				includeAllOption={false}
				onChange={(event) => setFieldValue('role', event.target.value)}
			/>
		</Grid>
	);
};
